import { gql } from '@apollo/client';

export const REMOVE_CARD = gql`
  mutation DeleteCard($cardId: String!, $setAnprFalse: Boolean) {
    deleteCard(cardId: $cardId, setAnprFalse: $setAnprFalse) {
      cardId
    }
  }
`;
